import { styling } from '../core/styling.js';

const wordBreak = styling({
    $wordBreak: {
        type: 'string',
        properties: ['wordBreak'],
    },
});

export { wordBreak };
//# sourceMappingURL=wordBreak.js.map
